import clsx from "clsx";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { SliderText, SliderWrapper } from "components/atoms/SliderText";
import { SectionTitle, Subtitle, TextBadge } from "components/atoms/Text";
import DividerSlider from "components/atoms/DividerSlider";

const Hero = () => {
    const [activeBaseService, setActiveBaseService] = useState(1);
    const [baseTimeService, setBaseTimeService] = useState(1);
    const [baseServiceType, setBaseServiceType] = useState(1);

    const [value, setValue] = useState(Number(1));
    const [monthly, setMonthly] = useState(Number(0));

    const basePrice = Number(`${baseServiceType === 1 && activeBaseService === 1 ? 5 :
        baseServiceType === 1 && activeBaseService === 2 ? 8 :
            baseServiceType === 2 && activeBaseService === 1 ? 10 : 15}`);

    const discount = Number(`${baseTimeService === 1 ? 10 : baseTimeService === 2 ? 14 : baseTimeService === 3 ? 18 : 20}`);

    const calculation = (value, baseprice, discount) => {
        const price = Math.round(value) * baseprice;
        const totalDiscount = price * (discount / 100);

        return Math.round(price - totalDiscount);
    };

    const changeHandler = useCallback((event) => {
        setValue(Number(event.target.value));
        setMonthly(calculation(Number(event.target.value), basePrice, discount));

        console.log(`current value ${event.target.value}`);
        console.log(`Result ${result}`);

        console.log(typeof result, " result");
        console.log(typeof value, " value");
        console.log(typeof basePrice, " base price");
    }, [value, discount, setMonthly, monthly]);

    useEffect(() => {
        const tooltip = document.querySelector(".tooltip-ranges");

        const sliderPricing = document.getElementById("slider-pricing");

        sliderPricing.addEventListener("change", (event) => {
            setValue(event.detail.value);
        });

        setMonthly(calculation(Number(value), basePrice, discount));

        if (value > 50 && value < 90) {
            tooltip.style.left = (value - 5.8) + "%";
        } else if (value >= 90) {
            tooltip.style.left = (value - 6.3) + "%";
        } if (value >= 95 && value <= 100) {
            tooltip.style.left = (value - 9.6) + "%";
        }
        else if (value === 0) {
            tooltip.style.left = (value - 3) + "%";
        } else if (value > 0 && value <= 18) {
            tooltip.style.left = (value - 4) + "%";
        } else {
            tooltip.style.left = (value - 4.8) + "%";
        }

        if (window.innerWidth <= 1024) {
            if (value > 50 && value < 90) {
                tooltip.style.left = (value - 6.2) + "%";
            } else if (value >= 90) {
                tooltip.style.left = (value - 5) + "%";
            } else if (value >= 99) {
                tooltip.style.left = (value - 13) + "%";
            } if (value >= 95 && value <= 100) {
                tooltip.style.left = (value - 11) + "%";
            }
            else if (value >= 0 && value < 2) {
                tooltip.style.left = (value - 2) + "%";
            } else if (value > 0 && value <= 18) {
                tooltip.style.left = (value - 4.9) + "%";
            } else {
                tooltip.style.left = (value - 5) + "%";
            }
        }

        if (window.innerWidth <= 1024) {
            if (value >= 99) {
                tooltip.style.left = (value - 11) + "%";
            }
        }

        if (window.innerWidth >= 375 && window.innerWidth < 768) {
            if (value > 50 && value < 84) {
                tooltip.style.left = (value - 16) + "%";
            } else if (value >= 84 && value <= 96) {
                tooltip.style.left = (value - 28) + "%";
            } else if (value >= 96 && value < 100) {
                tooltip.style.left = (value - 33) + "%";
            }
            else if (value >= 0 && value <= 18) {
                tooltip.style.left = (value - 2) + "%";
            } else {
                tooltip.style.left = (value - 13) + "%";
            }
        }

        if (window.innerWidth >= 375 && window.innerWidth < 768) {
            if (value >= 99) {
                tooltip.style.left = (value - 34) + "%";
            }
        }

        if (window.innerWidth > 768 && window.innerWidth <= 1024) {
            if (value > 94 && value < 95) {
                tooltip.style.left = (value - 7) + "%";
            }
        }
    }, [value, window.innerWidth, value, discount, setMonthly, monthly]);
    return (
        <Fragment>
            <section className="features w-full relative max-w-[1440px] mx-auto pt-[68px] tablet:pt-[67px] phone:pt-10 phone:top-[32px] tablet:top-[38px] desktop:top-[68px]">
                <img src='/images/homepage/pricing/brick.svg' className='absolute phone:hidden phone:right-[8px] phone:w-[85px] phone:h-[95px] phone:top-[80px] top-[56px] tablet:w-[86px] tablet:h-[96px] desktop:w-[153px] desktop:h-[170px] right-[108px] tablet:right-[54px] tablet:top-[82px]' width="194px" height="216px" alt="brick" />
                <img src='/images/homepage/pricing/brick-sm.svg' className='absolute phone:hidden phone:w-[60px] phone:h-[60px] top-[172px] left-[96px] phone:left-0 tablet:w-[86px] tablet:h-[96px] tablet:left-[32px]' width="116px" height="118px" alt="brick" />
                <section className={clsx(
                    "w-full mx-auto max-w-full md:max-w-[678px] bg-neutral-10 text-center",
                    "px-6 md:px-0"
                )}>
                    <TextBadge>Pricing Plan</TextBadge>
                    <SectionTitle classNames="phone:!text-heading-3 tablet:!text-[48px] tablet:!leading-[64.8px]">Lowest Price in The Industry</SectionTitle>
                    <Subtitle className="tablet:max-w-[544px] max-w-full">Our prices have always been competitive and we plan on keeping them that way. On top of that, we always have discounts based on quantity or billing period so make sure you play with our pricing calculator below to estimate your expenses.</Subtitle>
                </section>
                <section className={clsx(
                    "w-full px-6 tablet:px-8 desktop:px-[120px] phone:pt-12 tablet:pt-[64px] desktop:pt-[80px]"
                )}>
                    <div className={clsx(
                        "bg-primary-dark tablet:max-h-[401px] relative",
                        "rounded-2xl phone:p-4 tablet:p-[24px] desktop:p-10",
                        "w-full mx-auto phone:h-auto md:h-[473px]",
                        "flex flex-col justify-between overflow-hidden"
                    )}>
                        <img src="/images/homepage/pricing/path.svg" className="absolute tablet:w-[340px] bottom-[-17px] right-[-40px]" alt="path" />
                        <div className="flex flex-col md:flex-row space-y-[12px] md:space-y-0 justify-between items-start md:items-center">
                            <SliderWrapper classNames="flex items-center justify-between gap-0">
                                <SliderText onclick={() => setBaseTimeService(1)} classNames={`${baseTimeService !== 1 ? "!text-neutral-50" : ""}`} isActive={baseTimeService === 1} title="Monthly" />
                                {baseTimeService === 1 || baseTimeService === 2 ? "" : <DividerSlider />}
                                <SliderText onclick={() => setBaseTimeService(2)} classNames={`${baseTimeService !== 2 ? "!text-neutral-50" : ""}`} isActive={baseTimeService === 2} title="Quarterly" />
                                {baseTimeService === 2 || baseTimeService === 3 ? "" : <DividerSlider />}
                                <SliderText onclick={() => setBaseTimeService(3)} classNames={`${baseTimeService !== 3 ? "!text-neutral-50" : ""}`} isActive={baseTimeService === 3} title="Bi-Annually" />
                                {baseTimeService === 3 || baseTimeService === 4 ? "" : <DividerSlider />}
                                <SliderText onclick={() => setBaseTimeService(4)} classNames={`${baseTimeService !== 4 ? "!text-neutral-50" : ""}`} isActive={baseTimeService === 4} title="Yearly" />
                            </SliderWrapper>
                            <div className="phone:w-full flex flex-col space-y-[12px] md:space-y-0 md:flex-row items-start md:items-center space-x-0 md:space-x-4">
                                <SliderWrapper classNames="phone:w-full flex justify-between phone:items-center gap-1">
                                    <SliderText onclick={() => setActiveBaseService(1)} classNames={`phone:w-full ${activeBaseService !== 1 ? "!text-neutral-50" : ""}`} isActive={activeBaseService === 1} title="HTTP Proxy" />
                                    <SliderText onclick={() => setActiveBaseService(2)} classNames={`phone:w-full ${activeBaseService !== 2 ? "!text-neutral-50" : ""}`} isActive={activeBaseService === 2} title="SOCKSV5" />
                                </SliderWrapper>
                                <SliderWrapper classNames="phone:w-full flex gap-1 justify-between phone:items-center">
                                    <SliderText onclick={() => setBaseServiceType(1)} classNames={`phone:w-full ${baseServiceType !== 1 ? "!text-neutral-50" : ""}`} isActive={baseServiceType === 1} title="Dedicated" />
                                    <SliderText onclick={() => setBaseServiceType(2)} classNames={`phone:w-full ${baseServiceType !== 2 ? "!text-neutral-50" : ""}`} isActive={baseServiceType === 2} title="Shared" />
                                </SliderWrapper>
                            </div>
                        </div>
                        <div className="phone:mb-0 relative mt-10 phone:mt-[87px]">
                            <tc-range-slider
                                id="slider-pricing"
                                mousewheel-disabled="true"
                                keyboard-disabled="true"
                                slider-width="99%"
                                slider-height="12px"
                                slider-bg="#1A2942"
                                slider-bg-hover="#1A2942"
                                slider-bg-fill="#645AFF"
                                pointer-width="28px"
                                pointer-height="28px"
                                pointer-border="none"
                                pointer-border-hover="none"
                                pointer-border-focus="none"
                                pointer-bg="url(/images/proxy/pricing/pointer.svg) no-repeat 50% 50%"
                                pointer-bg-hover="url(/images/proxy/pricing/pointer.svg) no-repeat 50% 50%"
                                pointer-bg-focus="url(/images/proxy/pricing/pointer.svg) no-repeat 50% 50%"
                            >
                            </tc-range-slider>
                            {/* <input defaultValue={0} onChange={changeHandler} type="range" min={Number(0)} max={Number(100)} className="range range-primary" /> */}
                            <span className={clsx(
                                "tooltip-ranges phone:w-fit w-fit phone:px-3 px-3 text-[12px] rounded-md py-2 bg-white font-bold text-center text-primary-dark",
                                "absolute top-[-4.8em]",
                                value >= 95 ? "after:ml-[22px]" : "after:ml-[-8px]",
                                value === 0 ? "after:ml-[-22px]" : "",
                                value > 0 && value < 2 ? "tablet:after:ml-[-32px]" : "",
                                value <= 18 ? "phone:after:ml-[-36px]" : "",
                                value > 84 ? "phone:after:ml-[22px]" : "",

                            )}><span className="label-quantity font-normal text-[#677081]">Quantity :</span> {Math.round(value)}</span>
                            <div className="flex items-center justify-between mt-4">
                                <div className="flex flex-col items-center">
                                    <div className={clsx(
                                        "w-[6px] h-[6px] rounded-full absolute top-[3px] z-10",
                                        value < 0 ? "bg-neutral-60" : "bg-neutral-10"
                                    )}></div>
                                    <span className="text-neutral-50 phone:text-[12px] phone:leading-[14.94px] text-[16px]">0</span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className={clsx(
                                        "w-[6px] h-[6px] rounded-full absolute top-[3px] z-10",
                                        value < 25 ? "bg-neutral-60" : "bg-neutral-10"
                                    )}></div>
                                    <span className="text-neutral-50 phone:text-[12px] phone:leading-[14.94px] text-[16px]">25</span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className={clsx(
                                        "w-[6px] h-[6px] rounded-full absolute top-[3px] z-10",
                                        value < 50 ? "bg-neutral-60" : "bg-neutral-10"
                                    )}></div>
                                    <span className="text-neutral-50 phone:text-[12px] phone:leading-[14.94px] text-[16px]">50</span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className={clsx(
                                        "w-[6px] h-[6px] rounded-full absolute top-[3px] z-10",
                                        value < 75 ? "bg-neutral-60" : "bg-neutral-10"
                                    )}></div>
                                    <span className="text-neutral-50 phone:text-[12px] phone:leading-[14.94px] text-[16px]">75</span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <div className={clsx(
                                        "w-[6px] h-[6px] rounded-full absolute top-[3px] z-10",
                                        value < 100 ? "bg-neutral-60" : "bg-neutral-10"
                                    )}></div>
                                    <span className="text-neutral-50 phone:text-[12px] phone:leading-[14.94px] text-[16px]">100</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full bg-primary-darkhover relative z-30 rounded-lg phone:p-4 phone:mt-8 p-6 flex flex-col md:flex-row items-center justify-between md:h-[118px]">
                            <div className="phone:w-full flex items-center">
                                <div className="phone:w-full phone:grid-cols-2 w-fit grid grid-cols-2 phone:gap-6 gap-12">
                                    <div className="">
                                        <h1 className={clsx(
                                            "font-medium phone:text-heading-5 text-heading-4",
                                            "text-neutral-10"
                                        )}>${basePrice}</h1>
                                        <p className='text-[14px] phone:text-[13px] leading-[23.8px] font-normal text-basier-circle-regular pt-1 text-neutral-50'>Base Price</p>
                                    </div>
                                    <div className="">
                                        <h1 className={clsx(
                                            "font-medium phone:text-heading-5 text-heading-4",
                                            "text-neutral-10"
                                        )}>{discount}%</h1>
                                        <p className='text-[14px] phone:text-[13px] leading-[23.8px] font-normal text-basier-circle-regular pt-1 text-neutral-50'>Discount</p>
                                    </div>
                                </div>
                                <div className="ml-8 md:ml-20">
                                    <div className="">
                                        <h1 className={clsx(
                                            "font-medium phone:text-heading-5 text-heading-4",
                                            "text-primary-main"
                                        )}>${monthly}</h1>
                                        <p className='text-[14px] phone:text-[13px] leading-[23.8px] font-normal text-basier-circle-regular pt-1 text-neutral-50'>Monthly</p>
                                    </div>
                                </div>
                            </div>
                            <Link to="/auth/signin" className="phone:w-full phone:mt-6">
                                <button className="phone:w-full md:w-fit phone:h-[48px] h-[56px] flex items-center justify-center px-[46px] rounded-lg text-neutral-10 leading-[19.83px] font-semibold bg-primary-main hover:bg-primary-hover transition-all text-md">Buy Now</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </section>
            <section className="bg-primary-main w-full phone:mt-[-167px] phone:h-[256px] tablet:h-[256px] h-[310px] mt-[-136px]"></section>
        </Fragment>
    );
};

export default Hero;